import { type ChallengeTopic } from "@/challenges/utils/interfaces";
import ChallengesTeacherTopicCard from "./ChallengesTeacherTopicCard";
import {
  challengesListCss,
  challengesWrapper,
} from "./ChallengesTeacherTopicsList.style";

interface ChallengesTeacherTopicsListProps {
  topics: ChallengeTopic[];
}

const ChallengesTeacherTopicsList = ({
  topics,
}: ChallengesTeacherTopicsListProps) => {
  return (
    <div css={challengesWrapper}>
      <h3>Challenge Topics</h3>
      <div css={challengesListCss}>
        {topics.map((topic) => (
          <ChallengesTeacherTopicCard key={Math.random()} topic={topic} />
        ))}
      </div>
    </div>
  );
};

export default ChallengesTeacherTopicsList;
